import React, { useEffect } from 'react';
import { arrayOf, object, string, bool } from 'prop-types';
import classnames from 'classnames';
import { NotableClientsBar } from '@fiverr-private/seller_presence';
import { MP_VIEWED_NOTABLE_CLIENTS } from '../../../utils/mixPanelEvents';
import { NOTABLE_CLIENTS_ORIGIN } from '../../shared/NotableClients/constants';
import WithImpressions from '../../shared/withImpressions';
import './style.scss';

const CLASS_NAME = 'notable-clients-bar-local';

const NotableClientsBarLocal = ({
    notableClients,
    sellerName,
    profilePhoto,
    wrap,
    impressionRef,
    collectImpressions
}, { biEvents }) => {
    const notableClientMixPanelParams = {
        'source component': 'Gig page',
        'seller Name' : sellerName,
        'has sbss' : !!wrap,
        'number of clients' : notableClients.length
    };
    const barProps = {
        notableClients,
        seller: {
            name: sellerName,
            profilePhoto
        },
        titleProps: {
            educate: false
        },
        wrap,
        origin: NOTABLE_CLIENTS_ORIGIN
    };

    useEffect(() => {
        collectImpressions();
        biEvents.sendMixPanelEvent({
            eventName: MP_VIEWED_NOTABLE_CLIENTS,
            params: {
                ...notableClientMixPanelParams,
                'clients name' : notableClients.map((client) => client.name)
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={classnames(CLASS_NAME, { 'wrap-elements': wrap })} ref={impressionRef}>
            <NotableClientsBar {...barProps}/>
        </div>
    );
};

NotableClientsBarLocal.propTypes = {
    notableClients: arrayOf(object),
    sellerName: string,
    profilePhoto: string,
    wrap: bool
};

NotableClientsBarLocal.contextTypes = {
    biEvents: object
};

const impressionConfig = {
    DOMSelector: `.${CLASS_NAME} > div`,
    eventKey: 'notable_client_above_the_fold_component_is_shown'
};

export { NotableClientsBarLocal };
export default WithImpressions(NotableClientsBarLocal, impressionConfig);
